export default __webpack_public_path__ + "static/media/avatar-1.370a4ea2.png";